import { IObject } from "@quest/base-core";
import { reelPanel, slot } from "@quest/slot-core";
import { BehaviorCoreModule } from "@quest/murka-games-behavior-panther/dist";

//  BASE GAME
import { BaseControllerGame } from "./Base/BaseControllerGame";
import { BaseGameViewGame } from "./Base/BaseGameViewGame";
import { FreeGameMetersControllerGame } from "./FreeGame/FreeGameMetersControllerGame";
import { MetersControllerGame } from "./Base/MetersControllerGame";
import { ButtonControllerGame } from "./Base/ButtonControllerGame";
import { ReelPanelControllerGame } from "./Base/ReelPanelControllerGame";
import { WinPresentationControllerGame } from "./Base/WinPresentationControllerGame";
import { BaseGameModel } from "./model/BaseGameModel";
import { GameClientLogic } from "./Logic/GameClientLogic";
import { gameConstants } from "./Constants/gameConstants";
import { SettingPanelController } from "./Base/SettingPanelController";
import { PostLoadingControllerGame } from "./PostLoading/PostLoadingControllerGame";
import { GameIntroControllerGame } from "./GameIntro/GameIntroControllerGame";


//  INTRO OUTRO
import { IntroOutroControllerGame } from "./IntroOutro/IntroOutroControllerGame";

// BIG WIN
import { BigWinControllerFgGame } from "./BigWin/BigWinControllerFgGame";


// FREE GAME
import { FreeGameView } from "./FreeGame/FreeGameView";
import { FreeGameControllerGame } from "./FreeGame/FreeGameControllerGame";
import { FreeGameReelPanelControllerGame } from "./FreeGame/FreeGameReelPanelController";
import { BackgroundControllerGame } from "./Background/BackgroundControllerGame";
import { FreeGameWinPresentationControllerGame } from "./FreeGame/FreeGameWinPresentationControllerGame";
import { ReelGame } from "./ReelPanel/Reel";
import { FreeGameModel } from "./model/FreeGameModel";
import { BigWinControllerGame } from "./BigWin/BigWinControllerGame";
import { WinPresentationPanelGame } from "./ReelPanel/WinPresentationPanel";
import { RetriggerControllerGame } from "./Retrigger/RetriggerControllerGame";
import { PlayerMsgControllerGame } from "./playermessage/PlayerMsgControllerGame";
import { BlurBackgroundControllerGame } from "./BlurBackground/BlurBackgroundController";
import { TopLogoViewFgGame } from "./TopLogo/TopLogoViewFgGame";
import { IntroOutroViewGame } from "./IntroOutro/IntroOutroViewGame";
import { TopLogoControllerGameFg } from "./TopLogo/TopLogoControllerGameFg";
import { TopLogoControllerGame } from "./TopLogo/TopLogoControllerGame";
import { TopLogoViewGame } from "./TopLogo/TopLogoViewGame";
import { GameIntroViewGame } from "./GameIntro/GameIntroViewGame";

// This is only for adding coreModuleList in final game js else use gameConstants directly//
export let game: IObject = {
  gameConstants: gameConstants,
};

BehaviorCoreModule.GameIntroController = GameIntroControllerGame;
BehaviorCoreModule.GameIntroView = GameIntroViewGame;
BehaviorCoreModule.FreeGameController = FreeGameControllerGame;
BehaviorCoreModule.FreeGameView = FreeGameView;
BehaviorCoreModule.PostLoadingController = PostLoadingControllerGame;
BehaviorCoreModule.BaseController = BaseControllerGame;
BehaviorCoreModule.BaseView = BaseGameViewGame;
BehaviorCoreModule.IntroOutroController = IntroOutroControllerGame;
BehaviorCoreModule.IntroOutroView = IntroOutroViewGame;
BehaviorCoreModule.SettingPannelController = SettingPanelController;
BehaviorCoreModule.BigWinControllerFg = BigWinControllerFgGame;
BehaviorCoreModule.BigWinController = BigWinControllerGame;
slot.SlotLogic = GameClientLogic;
slot.BaseWinPresentationController = WinPresentationControllerGame;
slot.BaseReelPanelController = ReelPanelControllerGame;
slot.BaseMetersController = MetersControllerGame;
slot.BaseButtonController = ButtonControllerGame;
BehaviorCoreModule.FreeGameReelPanelController = FreeGameReelPanelControllerGame;
BehaviorCoreModule.BaseModel = BaseGameModel;
BehaviorCoreModule.BackgroundController = BackgroundControllerGame;
BehaviorCoreModule.FreeGameWinPresentationController = FreeGameWinPresentationControllerGame;
reelPanel.Reel = ReelGame;
reelPanel.WinReelPanel = WinPresentationPanelGame;
BehaviorCoreModule.FreeGameModel = FreeGameModel;
BehaviorCoreModule.FreeGameMetersController = FreeGameMetersControllerGame;
BehaviorCoreModule.RetriggerController = RetriggerControllerGame;
BehaviorCoreModule.PlayerMsgController = PlayerMsgControllerGame;
BehaviorCoreModule.BlurBackgroundController = BlurBackgroundControllerGame;
BehaviorCoreModule.TopLogoViewFg = TopLogoViewFgGame;
BehaviorCoreModule.TopLogoControllerFg = TopLogoControllerGameFg;
BehaviorCoreModule.TopLogoController = TopLogoControllerGame;
BehaviorCoreModule.TopLogoView = TopLogoViewGame;

